import React, { useState, useCallback, useEffect } from "react";
import s from "./Header.module.css";
import { NavLink } from "react-router-dom";
import logo2_light from "../../assets/logo2.png";
import logo2_dark from "../../assets/logo2_dark_theme.png";
import Burger from "../Burger/Burger";
import ModalHeaderMenu from "../Modal/ModalHeaderMenu/ModalHeaderMenu";
import { useTheme } from "../ThemeContext/ThemeContext";

// Импортируем иконки
import { FaSun, FaMoon } from "react-icons/fa";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 810);
  const { isDark, toggleTheme } = useTheme();

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseModal = () => {
    setIsMenuOpen(false);
  };

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= 810);
    if (window.innerWidth > 810) {
      handleCloseModal();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
    <div className={s.header}>
      <div className={s.logo_wrapper}>
        <NavLink className={s.logo_link} to="/portfolio">
          <img src={isDark ? logo2_dark : logo2_light} alt="logo" />
        </NavLink>
      </div>
      <div className={s.nav_wrapper}>
        {isMobile ? (
          <>
            <button
              onClick={toggleTheme}
              className={s.theme_toggle}
              title={isDark ? "Light Mode" : "Dark Mode"}
            >
              <div className={s.theme_switch}>
                {isDark ? (
                  <FaSun className={s.theme_icon} />
                ) : (
                  <FaMoon className={s.theme_icon} />
                )}
              </div>
              <span className={`${s.theme_text} ${s.theme_text_day}`}>
                DAYMODE
              </span>
              <span className={`${s.theme_text} ${s.theme_text_night}`}>
                NIGHTMODE
              </span>
            </button>
            <Burger onClick={handleMenuToggle} />
            <ModalHeaderMenu isOpen={isMenuOpen} onClose={handleCloseModal} />
          </>
        ) : (
          <>
            <NavLink className={s.nav_link} to="/portfolio">
              Start
            </NavLink>
            <NavLink className={s.nav_link} to="/designe">
              Interiors
            </NavLink>
            <NavLink className={s.nav_link} to="/arts">
              Arts
            </NavLink>
            <NavLink className={s.nav_link} to="/about">
              About
            </NavLink>
            <NavLink className={s.nav_link} to="/contacts">
              Contacts
            </NavLink>
            <button
              onClick={toggleTheme}
              className={s.theme_toggle}
              title={isDark ? "Light Mode" : "Dark Mode"}
            >
              <div className={s.theme_switch}>
                {isDark ? (
                  <FaSun className={s.theme_icon} />
                ) : (
                  <FaMoon className={s.theme_icon} />
                )}
              </div>
              <span className={`${s.theme_text} ${s.theme_text_day}`}>
                DAYMODE
              </span>
              <span className={`${s.theme_text} ${s.theme_text_night}`}>
                NIGHTMODE
              </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
}
